<template>
    <section>
        <form class="mt-5 md:text-sm" >
            <div class="flex">
                <p class="text-white rounded w-1/2 p-2 text-center" style="background-color:#0048AE">Tranfer Funds</p>
                <!-- <div class="w-full">
                    <select class="border w-full ml-3 rounded p-2" name="transfer" id="transfer" v-model="receiver">
                    <option value="user">To User</option>
                    <option value="rider">To Rider</option>
                    </select>
                    <p v-if="receiverValidity === 'invalid' " class="ml-3 md:ml-0 text-xs text-red-500">this field cannot be empty.</p>
                </div> -->
                
            </div>

            <div class="mt-5">
                <div class="flex md:flex-col">
                    <div class="w-1/2 md:w-full">
                        <select class="w-full border p-2 rounded" name="transferMedium" id="transferMediumum " @change="transferMedium($event)">
                            <option value="transfer">Transfer to:</option>
                            <option value="bank">Bank</option>
                            <option value="wallet">Wallet</option>
                        </select>
                        <p v-if="transferMediumValidity === 'invalid' " class="text-xs text-red-500">this field cannot be empty.</p>
                    </div>
                    <div class="w-1/2 ml-2 md:w-full md:ml-0">
                        <input class="w-full border p-2 rounded" type="text" name="number" id="number" placeholder="Enter Account Number" v-model="accountNumber">
                        <p class="mt-1">Account Name: {{accountName}}{{bankAccountName}} </p>
                        <p v-if="accountNumberValidity === 'invalid' " class="text-xs text-red-500">this field cannot be empty.</p>
                    </div>
                </div>
                
            </div>
            <div v-show="bankList" class="mt-5">
                <label class="mt-2" for="bank">Select Bank</label>
               <select class="border w-full  rounded p-2"  name="bank" id="bank" @click="getAccountName" @change="selectedBank($event)" v-model="bank">
                    <option @click="getAccountName"   v-for="bank in sortedArray" :key="bank" :value="bank">{{bank}}</option>
               </select>
                <p v-if="bankValidity === 'invalid'" class="text-xs text-red-500">please select Bank.</p>
            </div>
            <div @click="getAccountName" class="mt-5">
                <input @click="getWalletAccountName" class="w-full border p-2 rounded" type="text" name="description" id="description" placeholder="Enter Description" v-model="description" maxlength="15">
                <p v-if="descriptionValidity === 'invalid' " class="text-xs text-red-500">this field cannot be empty.</p>
            </div>
            <div class="mt-5 flex md:flex-col">
                <div class="w-1/2 md:w-full">
                    <input  class="border p-2 rounded w-full" type="number" name="amount" id="amount" placeholder="Enter Amount" v-model="amount">
                    <p class="text-red-500 text-xs" v-show="insufficient">Insufficient Fund</p>
                    <p v-if="amountValidity === 'invalid' " class="text-xs text-red-500">this field cannot be empty.</p>
                </div>
                <div class="w-1/2 md:w-full md:mt-2 relative">
                    <input @click="_insufficient" class="ml-3 md:ml-0 border rounded p-2 w-full"  :type="[showPassword ? 'text' : 'password']" name="password" id="password" placeholder="Enter Admin Password" v-model="password">
                    <span @click="showPassword = !showPassword" >
                        <i class="fa absolute right-2 bottom-4 mt-4" :class="[showPassword ? 'fa-eye' : 'fa-eye-slash']" aria-hidden="false" ></i>
                    </span>
                    <p v-if="passwordValidity === 'invalid' " class="text-xs text-red-500">this field cannot be empty.</p>
                </div>
                
            </div>
            
            <div class="mt-5">
                <p @click="showModal" class="cursor-pointer text-white rounded w-1/2 p-2 md:p-1 text-center" style="background-color:#0048AE">Proceed to Transfer</p>
            </div>
        </form>

        <div>
            <TransactionModal
             v-show="isModalVisible"
            @close="closeModal"
            :receiver="receiver"
            :password="password"
           :accountNumber="accountNumber"
           :accountName="accountName"
           :bankAccountName="bankAccountName"
           :code="code"
           :bank="bank"
           :amount="amount"
           :description="description"
           :medium="medium"
            />
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import TransactionModal from './TransactionModal.vue';
import {baseUrl} from '../../../../Config';
const url = baseUrl;
export default {
    components: {
        TransactionModal
    },

    data() {
        return {
           isModalVisible: false,
           banks: [],
           bank: "",
           code:"",
           amount: "".toLocaleString(),
           codes:[],
           receiver: "",
           description: "",
           password: "",
           accountNumber: "",
           accountNo : "",
           userEmail: "",
           accountName : "",
           receiverValidity: "",
           bankValidity: "",
           accountNumberValidity:"",
           transferMediumValidity:"",
           descriptionValidity: "",
           passwordValidity:"",
           amountValidity: "",

           insufficient: false,
           balance: this.$store.state.accountBalance,
           medium: "",
           bankList: false,
           token: localStorage.getItem("token"),
           showPassword: false,
           bankAccountName: ""
        }
    },

     computed: {
        sortedArray() {
            return this.banks.slice().sort(function(a,b) {
                return (a > b) ? 1 : -1
            });
        }
    },

    mounted() {
        this.getBank();
        this.getWalletAccountName();
        this.getAccountName();
    },

   

    methods: {
        transferMedium(event) {
            this.medium = event.target.value;
            if(this.medium === "bank") {
                this.bankList = true;
            } else{
                this.bankList = false
            }
        },
        showModal() {
             if(!this.accountNumber) {
                this.accountNumberValidity = "invalid";
                setTimeout(() => {
                this.accountNumberValidity = "";
                }, 3000);
            } else if(this.transferMedium === "bank" && !this.bank) {
                this.bankValidity = "invalid";
                setTimeout(() => {
                this.bankValidity = "";
                }, 3000);
            } else if(!this.description) {
                this.descriptionValidity = "invalid";
                setTimeout(() => {
                this.descriptionValidity = "";
                }, 3000);
            } else if(!this.amount) {
                this.amountValidity = "invalid";
                setTimeout(() => {
                this.amountValidity = "";
                }, 3000);
            } else if(!this.password) {
                this.passwordValidity = "invalid";
                setTimeout(() => {
                this.passwordValidity = "";
                }, 3000);
            } else if(!this.medium) {
                this.transferMediumValidity = 'invalid';
                setTimeout(() => {
                this.transferMediumValidity = "";
                }, 3000);
            }
            else {
                this.isModalVisible = true;
            }
        },
        closeModal() {
            this.isModalVisible = false;
        },
        selectedBank(event){
            const bank = event.target.value;
            this.codes.map((c)=>{
               if (bank === c.name) {
                   this.code = c.code
               }
            })

        },
        
        getBank() {
            axios({
              method: 'GET',
              url: `${url}/v1/web/transactions/banks`,
              headers: {
                  'Content-type': 'application/json',
                  'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3',
                    authorization: `Bearer ${this.token}`
              },
          })
          .then((res)=>{
            let bank = res.data.data;
            for(let i=0; i < bank.length; i++) {
                   this.banks.push(bank[i].name);
                   let codeObj = {
                       name:bank[i].name,
                       code:bank[i].code
                   }
                   this.codes.push(codeObj)
                   
               }            
          })
          .catch((err) =>err.json)
        },

        getAccountName() {
            axios({
            method: 'POST',
            url: `${url}/v1/web/transactions/bank/resolve`,
            headers: {
                'Content-type': 'application/json',
                'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3',
                    authorization: `Bearer ${this.token}`
            },
            data: {
                accountNumber: String(this.accountNumber),
                bankCode: this.code
            }
          })
          .then((res) => {
              let detail = res.data.data;
              this.bankAccountName = detail.account_name;
          })
          .catch((err) =>err.json)
        },

        getWalletAccountName() {
            axios({
            method: 'GET',
            url: `${url}/v1/web/users/wallet/${this.accountNumber}`,
            headers: {
                'Content-type': 'application/json',
                'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3',
                    authorization: `Bearer ${this.token}`
            }
          })
          .then((res) => {
              let detail = res.data.data;
              this.accountName = detail.bankName;
          })
          .catch((err) =>err.json)
        }
    }
}
</script>